"use client";

import { useState } from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardHeader,
  CardFooter,
} from "@/components/ui/card";
import { Textarea } from "@/components/ui/textarea";
import { cn } from "@/lib/utils";

interface CreateCommentProps {
  user: {
    name: string;
    avatar?: string;
    role?: string;
  };
  onSubmit: (content: string) => void;
  bordered?: boolean;
}

export function CreateComment({
  user,
  onSubmit,
  bordered = true,
}: CreateCommentProps) {
  const [content, setContent] = useState("");

  const handleSubmit = () => {
    if (content.trim()) {
      onSubmit(content);
      setContent("");
    }
  };

  return (
    <Card
      className={cn(
        // "w-full max-w-3xl mx-auto mb-4",
        "w-full mb-4",
        bordered ? "shadow-sm" : "shadow-none border-none"
      )}
    >
      <CardHeader className="flex flex-row items-center gap-4 p-4">
        {user.avatar ? (
          <Avatar className="w-10 h-10">
            <AvatarImage src={user.avatar} alt={user.name} />
            <AvatarFallback>{user.name.charAt(0)}</AvatarFallback>
          </Avatar>
        ) : (
          <div className="flex items-center justify-center w-10 h-10 bg-gray-200 rounded-full">
            <span className="font-semibold text-gray-600">
              {user.name.charAt(0)}
            </span>
          </div>
        )}
        <div className="flex flex-col">
          <p className="text-sm font-semibold">{user.name}</p>
          {user.role && <p className="text-xs text-gray-500">{user.role}</p>}
        </div>
      </CardHeader>
      <CardContent className="p-4">
        <Textarea
          placeholder="Add a comment..."
          value={content}
          onChange={(e) => setContent(e.target.value)}
          className="min-h-[100px]"
        />
      </CardContent>
      <CardFooter className="flex justify-end p-4">
        <Button onClick={handleSubmit} disabled={!content.trim()}>
          Submit
        </Button>
      </CardFooter>
    </Card>
  );
}
